import React from 'react';
import { Edit, NumberInput, ReferenceInput, required, SelectInput, SimpleForm, TextInput } from 'react-admin';
import TargetGroupInput from '../../../../commonComponents/TargetGroupInput';
import ImageInput from '../../../../commonComponents/UploadInputs/ImageInput';
import { uploadTypes, statuses } from '../../../../config/constants';
import ConditionalColorInput from './ConditionalColorInput';
import { isHungary } from '../../../../helpers/appTypeHelper';
import { TiersPricesList } from '../../commonComponents/TiersPricesList';
import PresentEditToolbar from './PresentEditToolbar';

const PresentEdit = (props) => (
  <Edit title="Edit Present" undoable={false} {...props}>
    <SimpleForm toolbar={<PresentEditToolbar />}>
      <TextInput label="ID" source="id" disabled />
      <TextInput label="Name" source="name" validate={required()} />
      <TextInput label="Description" source="description" validate={required()} />
      <TextInput label="Price" source="price" validate={required()} />
      {isHungary() && <TiersPricesList {...props} />}
      <TextInput label="Promo price" source="promo_price" />
      <TextInput label="Nominal price" source="nominal_price" />
      <NumberInput label="Priority" source="priority" />
      <TargetGroupInput />
      <ReferenceInput label="Category" source="category_id" reference="admin/bonus-shop/categories/physical">
        <SelectInput optionText="name" validate={required()} />
      </ReferenceInput>
      <SelectInput source="status" optionText="name" choices={statuses.slice(0, 2)} validate={required()} />
      <ReferenceInput label="Type" source="type" reference="admin/bonus-shop/presents/types">
        <SelectInput optionText="name" validate={required()} />
      </ReferenceInput>
      <NumberInput label="Count" source="count" validate={required()} />
      <ConditionalColorInput />
      <ImageInput imageInputSource="photo" validate={required()} uploadType={uploadTypes.bonusShop} />
    </SimpleForm>
  </Edit>
);

export default PresentEdit;
